<template>
  <q-dialog
    :visible="isVisible"
    title="导入"
    width="500px"
    :innerScroll="false"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="uploadForm" :model="uploadForm" :rules="rules" label-width="80px">
      <el-form-item label="名称" prop="activity">
        <el-input v-model="uploadForm.activity" size="small" class="form-input"></el-input>
      </el-form-item>
      <el-form-item label="渠道" prop="channelSource">
        <el-select v-model="uploadForm.channelSource" size="small" clearable>
          <el-option v-for="item in channelOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件：" prop="file">
        <el-upload
          class="upload"
          :http-request="upload"
          action="*"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
          :on-change="onFileChange"
          :auto-upload="false"
          ref="upload">
          <el-button size="small" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传xls、xlsx文件，且大小不能超过10MB
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import { assignValue } from '@/utils'
import {SUB_APP_CODE} from '@/api/api'
export default {
  name: 'ImportFile',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    reportName: {
      type: String,
      default: 'importQuestion'
    },
    pushId: {
      type: Number
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      uploadForm: {
        activity: '',
        channelSource: 'pc导入',
        file: ''
      },
      channelOptions: [{
        label: "pc导入",
        value: 'pc导入'
      }],
      rules: {
        activity: [
          { required: true, message: '活动名称不能为空', trigger: 'blur' }
        ],
        channelSource: [
          { required: true, message: '渠道不能为空', trigger: 'change' }
        ],
        file: [
          { required: true, message: '文件不能为空', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    getChannelSource() {
      this.$api.customerMgmt.getChannelList()
        .then(({data}) => {
          if (Array.isArray(data)) {
            this.channelOptions = data.map(item => ({
              label: item.key,
              value: item.value
            }));
          }
        });
    },
    beforeUpload(file) {
      const excelTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      if (!excelTypes.includes(file.type)) {
        this.$message.error('只能上传Excel文件');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      return true;
    },
    onFileChange(file) {
      this.uploadForm.file = file;
      this.$refs.uploadForm.validateField('file');
    },
    upload({file}) {
      console.log('import:', file);
      const loading = this.$loading({
        lock: true,
        text: '文件导入中...',
        spinner: 'el-icon-loading'
      });
      let paramMap =  [
          {
            columnName: "活动",
            columnValue: this.uploadForm.activity,
            fieldName: "activity",
            fieldValue: this.uploadForm.activity,
          },
          {
            columnName: "渠道",
            columnValue: this.getLabelByValue(this.channelOptions, this.uploadForm.channelSource),
            fieldName: "channelSource",
            fieldValue: this.uploadForm.channelSource,
          }
        ]
      if (this.reportName == 'importPhone') {
        paramMap.push({fieldName: 'pushId',fieldValue: this.pushId})
      }

      const extData = {
        reportName: this.reportName,
        appCode: SUB_APP_CODE,
        paramMap,
      };
      this.$api.common.importFile(file, extData)
        .then((res) => {
          this.$notify.success({
            title: '成功',
            message: '导入数据成功'
          });
          this.onCancel();
          this.$emit('after',res.data || null);
        })
        .catch(err => {
          this.$message.error('导入数据失败，请重新导入！');
        })
        .finally(() => {
          loading.close();
        });
    },
    getLabelByValue(options = [], value) {
      const option = options.find(item => item.value === value);
      return option && option.label || '';
    },
    onCancel() {
      this.isVisible = false
    },
    onConfirm() {
      this.$refs.uploadForm.validate((valid) => {
        if (!valid) return;

        this.$refs.upload.submit();
      })
    }
  },
  created() {
    // this.getChannelSource();
  }
}
</script>

<style lang="stylus" scoped>
.upload
  >>> .el-upload__tip
    line-height 30px
    margin-top 0

</style>